/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Globals from "../shared/Globals";
import { qreq } from "../shared/qrequest";
import L from "./Lang"
import BaseCom from "./BaseCom";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";

class WoundDB extends BaseCom {
    componentDidMount() {
        qreq.get('/api/wound/list', j => {
            if(j.list)
                this.setState({list: j.list});
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }
    render() {
        return <div className="container-fluid">
            <h1><L>Wound Database</L></h1>
            <div className="row">
                {this.state.list?.map(i => <div className="col-md-3 col-6">
                    <img src={Globals.getImageURL(i.url)} className="img-fluid" alt="Wound" />
                </div>)}
            </div>
            
        </div>;
    }
}

export default withParamsAndNavigate(WoundDB);